import React, { createContext, useContext, useMemo } from "react";
import { useWinStore } from "./windowStore";

type WindowApi = {
  id: string;
  close: () => void;
  focus: () => void;
  minimize: () => void;
  maximize: () => void;
};
const Ctx = createContext<WindowApi | null>(null);

export const useWindow = () => {
  const ctx = useContext(Ctx);
  if (!ctx)
    throw new Error("useWindow must be used inside <WindowContextProvider>");
  return ctx;
};

export const WindowContextProvider: React.FC<{
  id: string;
  children: React.ReactNode;
}> = ({ id, children }) => {
  const { close, focus, toggleMinimize } = useWinStore((s) => s);
  const value = useMemo(
    () => ({
      id,
      close: () => close(id),
      focus: () => focus(id),
      minimize: () => toggleMinimize(id),
      maximize: () => {} // Función deshabilitada - botón de maximizar comentado
    }),
    [id, close, focus, toggleMinimize]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};
